import { memo } from 'react';
import type { IIconProps } from '../interfaces';

const LogoutIcon = (props: IIconProps) => {
  const { width = 24, height = 24, color = 'currentColor' } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.6875 8.0625L3.75 12L7.6875 15.9375" stroke={color} strokeWidth="1.50421" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.25 12H3.75" strokeWidth="1.50421" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.25 20.25H19.5C19.6989 20.25 19.8897 20.171 20.0303 20.0303C20.171 19.8897 20.25 19.6989 20.25 19.5V4.5C20.25 4.30109 20.171 4.11032 20.0303 3.96967C19.8897 3.82902 19.6989 3.75 19.5 3.75H14.25" stroke={color} strokeWidth="1.50421" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default memo(LogoutIcon);
